import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, brandPrimaryHover, grayIconFill, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	header: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		marginBottom: 16,
	},
	backButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontSize: 14,
		color: grayIconFill,
		padding: '4px 0',
		':hover': {
			textDecoration: 'underline',
		},
	},
	configName: {
		fontSize: 18,
		fontWeight: 600,
		margin: 0,
		flex: 1,
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		overflow: 'auto',
		flex: 1,
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '48px 0',
		gap: 16,
		color: grayIconFill,
	},
	loadingMore: {
		display: 'flex',
		justifyContent: 'center',
		padding: '16px 0',
	},
	// ScoreCard styles
	card: {
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		backgroundColor: white,
	},
	cardSuppressed: {
		opacity: 0.6,
		borderStyle: 'dashed',
	},
	cardHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		padding: 16,
		cursor: 'pointer',
		position: 'sticky' as const,
		top: 0,
		backgroundColor: white,
		borderRadius: '8px 8px 0 0',
		zIndex: 1,
	},
	cardHeaderCollapsed: {
		borderRadius: 8,
		':hover': {
			backgroundColor: '#fafafa',
		},
	},
	cardContactInfo: {
		flex: 1,
		minWidth: 0,
	},
	cardContactName: {
		fontSize: 15,
		fontWeight: 600,
		margin: 0,
		display: 'flex',
		alignItems: 'baseline',
		gap: 8,
		minWidth: 0,
	},
	cardContactLink: {
		color: brandPrimary,
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		font: 'inherit',
		fontWeight: 600,
		textAlign: 'left' as const,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		minWidth: 0,
		':hover': {
			color: brandPrimaryHover,
		},
	},
	cardReasoning: {
		fontSize: 13,
		lineHeight: 1.4,
		color: grayIconFill,
		margin: '4px 0 0',
		display: '-webkit-box' as any,
		WebkitLineClamp: 2,
		WebkitBoxOrient: 'vertical' as any,
		overflow: 'hidden',
		':nth-child(1n) p': {
			margin: 0,
			display: 'inline',
		},
	},
	expandHint: {
		fontSize: 12,
		color: brandPrimary,
		marginTop: 4,
		fontWeight: 500,
	},
	cardMeta: {
		fontSize: 13,
		color: grayIconFill,
		display: 'flex',
		gap: 8,
	},
	cardActions: {
		display: 'flex',
		flexDirection: 'column' as const,
		alignItems: 'flex-start',
		gap: 8,
		flexShrink: 0,
	},
	cardActionButtons: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	skipCheckboxLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		cursor: 'pointer',
	},
	skipLabel: {
		fontSize: 13,
		color: grayIconFill,
	},
	expandedSection: {
		padding: '0 16px 16px',
		borderTop: `1px solid ${borderColor}`,
		borderRadius: '0 0 8px 8px',
	},
	detailBlock: {
		marginTop: 12,
	},
	detailLabel: {
		fontSize: 12,
		fontWeight: 600,
		textTransform: 'uppercase' as const,
		color: grayIconFill,
		marginBottom: 4,
	},
	detailMarkdown: {
		fontSize: 14,
		lineHeight: 1.5,
		':nth-child(1n) p': {
			margin: '4px 0',
		},
		':nth-child(1n) ul, :nth-child(1n) ol': {
			margin: '4px 0',
			paddingLeft: 20,
		},
	},
	detailText: {
		fontSize: 14,
		lineHeight: 1.5,
		whiteSpace: 'pre-wrap',
		margin: 0,
	},
	notesRow: {
		marginTop: 12,
		display: 'flex',
		gap: 8,
		alignItems: 'flex-start',
	},
	notesTextarea: {
		flex: 1,
		minHeight: 60,
	},
	// ScoreIndicator styles
	scoreIndicator: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 44,
		height: 44,
		borderRadius: '50%',
		fontSize: 16,
		fontWeight: 700,
		flexShrink: 0,
		color: white,
	},
});
